import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.FitFive;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "FitFive.Phaser.IntroductionScene.1",
            "FitFive.Phaser.IntroductionScene.2",
            "FitFive.Phaser.IntroductionScene.3",
            "FitFive.Phaser.IntroductionScene.4",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/FitFiveGame/scenes/GameIntro.ts